export class Oc{
    oc:string;
    ea:string[] = []
}